import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import {
  brandSet,
  copyDescriptions,
  currenciesPricesUpdate,
  descriptionHistoryLoad,
  dimensionsUpdate,
  load,
  namesDescriptionsSlugsUpdate,
  photoDelete,
  photoDownloadFromUrlsAction,
  photoPositionSave,
  photoVisibleChange,
  productAIEnhanceDescription,
  productAIEnhanceDescriptionAllLanguages,
  productAIGenerateMeta,
  productAIGenerateMetaAllLanguages,
  productAITranslateNameAllLanguages,
  productAssignRelatedProducts,
  productDashboardLoad,
  productFeatureFlagDestroy,
  productPropertiesSave,
  productRecalculatePrices,
  productSetActive,
  productSetEndPriceMarginRate,
  productsFindInElasticSearch,
  saveCategories,
  stockUpdate,
} from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(productAIEnhanceDescription.type, send, socket);
  yield takeEvery(productAIEnhanceDescriptionAllLanguages.type, send, socket);
  yield takeEvery(productAITranslateNameAllLanguages.type, send, socket);
  yield takeEvery(productAIGenerateMeta.type, send, socket);
  yield takeEvery(productAIGenerateMetaAllLanguages.type, send, socket);
  yield takeEvery(descriptionHistoryLoad.type, send, socket);
  yield takeEvery(productDashboardLoad.type, send, socket);
  yield takeEvery(productAssignRelatedProducts.type, send, socket);
  yield takeEvery(brandSet.type, send, socket);
  yield takeEvery(copyDescriptions.type, send, socket);
  yield takeEvery(currenciesPricesUpdate.type, send, socket);
  yield takeEvery(dimensionsUpdate.type, send, socket);
  yield takeEvery(productFeatureFlagDestroy.type, send, socket);
  yield takeEvery(load.type, send, socket);
  yield takeEvery(namesDescriptionsSlugsUpdate.type, send, socket);
  yield takeEvery(photoDelete.type, send, socket);
  yield takeEvery(photoDownloadFromUrlsAction.type, send, socket);
  yield takeEvery(photoPositionSave.type, send, socket);
  yield takeEvery(photoVisibleChange.type, send, socket);
  yield takeEvery(productsFindInElasticSearch.type, send, socket);
  yield takeEvery(productPropertiesSave.type, send, socket);
  yield takeEvery(productRecalculatePrices.type, send, socket);
  yield takeEvery(saveCategories.type, send, socket);
  yield takeEvery(productSetActive.type, send, socket);
  yield takeEvery(productSetEndPriceMarginRate.type, send, socket);
  yield takeEvery(stockUpdate.type, send, socket);
}
